export default __webpack_public_path__ + "static/media/007-placeholders-1.c5b03893.png";